var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachineLink = function SvgMachineLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.633 7.5a4.163 4.163 0 0 1 4.159-4.16h5.367V.793H6.792A6.71 6.71 0 0 0 .083 7.5a6.71 6.71 0 0 0 6.709 6.708h5.367V11.66H6.792A4.163 4.163 0 0 1 2.632 7.5m5.5 1.342h10.734V6.158H8.133zM20.21.792h-5.367V3.34h5.367A4.163 4.163 0 0 1 24.368 7.5a4.163 4.163 0 0 1-4.16 4.16h-5.366v2.548h5.367A6.71 6.71 0 0 0 26.917 7.5 6.71 6.71 0 0 0 20.208.792"
  })));
};
export default SvgMachineLink;